import { useTitle } from 'react-use';

import { Layout } from 'CorePackage/MainModule/components/Layout';

import { PersonalAccount } from './PersonalAccount';

export const PersonalAccountPage = () => {
  useTitle('Личный кабинет');

  return (
    <Layout withFooter>
      <PersonalAccount />
    </Layout>
  );
};
